class CartonDiscovery extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-carton-submit]');
    this.status = this.querySelector('[data-carton-status]');
    this.button?.addEventListener('click', this.addCarton);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.addCarton);
  }

  addCarton = async () => {
    if (!this.button || this.button.disabled) return;

    let items = [];
    try {
      items = JSON.parse(this.dataset.items || '[]');
    } catch {
      this.showError('La composition du carton est momentanément indisponible.');
      return;
    }

    if (items.length !== 6) {
      this.showError('Une bouteille du carton est momentanément indisponible.');
      return;
    }

    const initialLabel = this.button.textContent;
    this.button.disabled = true;
    this.button.textContent = 'Ajout du carton…';

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });

      if (!response.ok) throw new Error('cart-add-failed');
      const cartUrl = `${root}cart`;
      window.location.assign(cartUrl);
    } catch {
      this.button.disabled = false;
      this.button.textContent = initialLabel;
      this.showError('Le carton n’a pas pu être ajouté. Vérifiez les disponibilités et réessayez.');
    }
  };

  showError(message) {
    if (!this.status) return;
    this.status.textContent = message;
    this.status.hidden = false;
  }
}

if (!customElements.get('carton-discovery')) {
  customElements.define('carton-discovery', CartonDiscovery);
}
